module.exports = __webpack_public_path__ + "./images/b97218a3961f876acac9eb96c026cd93.webp";